export default {
  'user-groups.title': 'Manage User Groups',
  'user-groups.groupUsers.description': 'Add or remove users from the group {name}.',
  'user-groups.userExists': 'The user already belongs to this group',
};
